import Config from '@config';
import { initializeMeteringNodeApi } from '@gasbi/shared/common/features/meteringNode';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import './__mocks__';

const meteringNode = initializeMeteringNodeApi({
  baseUrl: Config.VITE_API_URL,
  baseQuery: axiosBaseQuery,
});

export const {
  meteringNodeApi,
  useGetMeteringNodesQuery,
  useCreateMeteringNodeMutation,
  useGetMeteringNodeByIdQuery,
  useUpdateMeteringNodeByIdMutation,
  useGetMeteringNodesInfiniteQuery,
} = meteringNode;
